package io.horion.cv.api.datasource.job

import kotlinx.serialization.Serializable

@Serializable
enum class JobType {
    CDI, CDD, STAGE, FREELANCE, INTERIM, LEARNING
}